// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__nhbeB","_fixed":"Tabs__fixed__Tpg13","tabs__inner":"Tabs_tabs__inner__OcWlR","tabs__wrapper":"Tabs_tabs__wrapper__MlzIJ"};